const aplCatlCode = {
    PON4300: '650',
    CONTACT: '631',
    POLICY: '640',
    MULTI_ENOTIFY: '670',
    MULTI_PAY_CHANGE: '700',
    ACH: '720',
    CREDIT_CARD_EXP: '710',
    E_NOTIFY_PROMO: '820',
    A3: 'A3',
    A4: 'A4',
    A5: 'A5',
    A6: 'A6',
    VIP: 'vip',
    PAY_PCC: 'PAY_ACC',
};

Object.freeze(aplCatlCode);
export default aplCatlCode;
